import { ContentState, EditorState } from "draft-js";

import AtomicBlockIdentifiers from "./AtomicBlockIdentifiers";
import EntityTypeIdentifiers from "./EntityTypeIdentifiers";
import insertMentionEntity from "./mentions/insertMentionEntity";
import isEditorStateEmpty from "./utils/isEditorStateEmpty";

/**
 * @type {Function}
 */
const noop = () => {};

const EditorStateUtils = {
  /**
   * @param   {EditorState} editorState
   * @returns {[]EditorMention}
   */
  getMentions: function getMentions(editorState) {
    const contentState = editorState.getCurrentContent();
    const mentions = [];

    contentState.getBlocksAsArray().forEach(block => {
      block.findEntityRanges(character => {
        if (character.getEntity() !== null) {
          const entity = contentState.getEntity(character.getEntity());
          const entityType = entity.getType();

          if (entityType === EntityTypeIdentifiers.MENTION) {
            mentions.push(entity.getData());
          }
        }
      }, noop);
    });

    return mentions;
  },

  /**
   * @param   {EditorState} editorState
   * @returns {[]String}
   */
  getLinkUrls: function getLinkUrls(editorState) {
    const links = [];
    const contentState = editorState.getCurrentContent();

    contentState.getBlocksAsArray().forEach(block => {
      block.findEntityRanges(character => {
        if (character.getEntity() !== null) {
          const entity = contentState.getEntity(character.getEntity());
          const entityType = entity.getType();

          if (entityType === EntityTypeIdentifiers.LINK) {
            links.push(entity.getData().url);
          }
        }
      }, noop);
    });

    return links;
  },

  /**
   * @param   {EditorState} editorState
   * @returns {[]String}
   */
  getTextContentsBlocks: function getTextContentsBlocks(editorState) {
    return editorState
      .getCurrentContent()
      .getBlocksAsArray()
      .map(block => block.getText())
      .filter(Boolean);
  },

  /**
   * @param   {EditorState} editorState
   * @returns {[]String}
   */
  getImageUrls: function getImageUrls(editorState) {
    const blocks = editorState.getCurrentContent().getBlocksAsArray();

    return blocks
      .filter(block => {
        if (block.getType() === "atomic") {
          const blockType = block.getData().get("blockType");
          return blockType === AtomicBlockIdentifiers.IMAGE;
        } else {
          return false;
        }
      })
      .map(block => block.getData().get("imageUrl"));
  },

  /**
   * @param   {EditorState} editorState
   * @returns {[]String}
   */
  getYouTubeUrls: function getYoutubeUrls(editorState) {
    const blocks = editorState.getCurrentContent().getBlocksAsArray();

    return blocks
      .filter(block => {
        if (block.getType() === "atomic") {
          const blockType = block.getData().get("blockType");
          return blockType === AtomicBlockIdentifiers.YOUTUBE_VIDEO;
        } else {
          return false;
        }
      })
      .map(block => block.getData().get("videoUrl"));
  },

  /**
   * @param   {EditorState} editorState
   * @returns {Boolean}
   */
  isEditorStateEmpty,

  /**
   * @param   {EditorMention} mention
   * @returns {EditorState}
   */
  createWithMention: function createWithMention(mention) {
    const contentState = ContentState.createFromText(mention.getDisplayText());
    const editorState = EditorState.createWithContent(contentState);

    return insertMentionEntity(
      editorState,
      editorState.getSelection().merge({
        anchorOffset: 0,
        anchorKey: contentState.getFirstBlock().getKey(),
        focusOffset: mention.getDisplayText().length,
        focusKey: contentState.getLastBlock().getKey(),
      }),
      mention.getDisplayText(),
      mention,
      mention.getMutability(),
    );
  },
};

export default EditorStateUtils;
